import InfoCircle from '../src/InfoCircle';
export default InfoCircle;
